import Main from './main';
import { connect } from 'react-redux';

import { SetUser } from 'actions/result';

export default connect(
  state => ({
    data: state.data.data,
    result: state.result,
  }),
  {
    SetUser,
  },
)(Main);
